import React from "react"

import { Container } from "./styles"

const Banner = ({ banner, isPrimary = false }) => (
  <Container
    isPrimary={isPrimary}
    dangerouslySetInnerHTML={{ __html: banner?.childMarkdownRemark?.html }}
  />
)

export default Banner
